import EmptyView from "common/Empty/EmptyView.tsx";
import PanelEmpty from "common/Empty/PanelEmpty.tsx";
import { EmptyStatesType } from "common/Icons/types.ts";
import { publicBotsFilters } from "@shared/slices/filters.slice.ts";
import { TABLET } from "common/constants.ts";
import React from "react";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { useBottomNavigator, useHeaderSearchValue } from "utils/hooks/misc.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import { LanguageNameSpaces } from "@shared/types";

interface EmptyPublicBotsProps {
  searchValue?: string;
  openFilters?: () => void;
  /** New look: inside a panel (the bot form's tab), without the mark. */
  inPanel?: boolean;
}

const EmptyPublicBots = ({
  searchValue,
  openFilters,
  inPanel,
}: EmptyPublicBotsProps) => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const { t: tCommon } = useTypedTranslation(LanguageNameSpaces.COMMON);
  const { isNewLook } = useTheme();
  const { baseShouldDisplay: isBottomNavigator } = useBottomNavigator();
  const headerSearch = useHeaderSearchValue(searchValue);
  const numActiveFilters = useSelector(
    publicBotsFilters.selectors.selectNumActiveFilters
  );

  if (isNewLook && inPanel) {
    return (
      <PanelEmpty
        title={
          numActiveFilters
            ? tCommon("empty.no_results_matching_filters", {
                objectName: t("public_bots.public_bots"),
              })
            : t("empty_states.no_public_bots")
        }
        description={t("public_bots.empty_description")}
      />
    );
  }

  return (
    <EmptyView
      iconKey={EmptyStatesType.Bots}
      iconWidth={220}
      title={t("empty_states.no_public_bots")}
      description={isNewLook ? t("public_bots.empty_description") : undefined}
      objectName={t("public_bots.public_bots")}
      filtersSlice={publicBotsFilters}
      isSearch={!!headerSearch?.length}
      filtersChipsOpen={TABLET}
      openFilters={openFilters}
      style={
        isBottomNavigator
          ? { padding: "48px 16px", height: "fit-content" }
          : undefined
      }
    />
  );
};

export default EmptyPublicBots;
